import { useRef, useState } from 'react';

type IFormValues<T = Record<string, string | number | boolean | null>> = {
  [K in keyof T]: T[K];
};

export const useForm = <T extends IFormValues>(defaultValues: T) => {
  const originalValues = useRef(defaultValues);
  const [form, setForm] = useState<T>(defaultValues);

  const register = <K extends keyof T>(
    name: K,
    options?: { required: boolean }, // make it so it works :3
  ) => {
    const setValue = (value: T[typeof name]) => {
      setForm(prev => ({ ...prev, [name]: value }));
    };

    return { name, value: form[name], setValue };
  };

  const onReset = () => {
    setForm(originalValues.current);
  };

  return { register, form, onReset };
};
